<template>
  <div>
    <b-modal id="deposit" ref="modal" title="Deposit $PXL" @ok="handleSubmit" ok-title="Deposit">
      <p>Deposit $PXL in order to use it in games.</p>
      <b-form ref="depositForm" @submit.stop.prevent="handleSubmit" novalidate>
        <b-form-group label="Amount" label-for="amount-input" invalid-feedback="Amount is required">
          <b-form-input
            id="amount-input"
            v-model="amount"
            type="number"
            :state="amountState"
            required
          ></b-form-input>
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { OpKind } from '@taquito/taquito'
import { tzip16 } from '@taquito/tzip16'

import { convertFromMutez, convertToMutez } from '../../util'
import { handleGlobalError } from '../../util'

export default {
  data() {
    return {
      amount: null,
    }
  },
  computed: {
    tezos() {
      return this.$store.getters.tezos
    },
    wallet() {
      return this.$store.getters.wallet
    },
    connectedWalletAddress() {
      return this.$store.getters.connectedWalletAddress
    },
    user() {
      return this.$store.getters.user
    },
    walletAddress() {
      return this.user ? this.user.walletAddress : null
    },
    pxlBalance() {
      return this.$store.getters.pxlBalance
    },
    amountState() {
      return this.amount > 0
    },
    config() {
      return this.$store.getters.config
    },
  },
  methods: {
    async depositPxl() {
      try {
        const pxlAmount = convertToMutez(this.amount)
        const pxlEscrow = await this.tezos.wallet.at(process.env.VUE_APP_PXL_ESCROW, tzip16)
        const pxlMain = await this.tezos.wallet.at(process.env.VUE_APP_PIXEL, tzip16)
        let op = null

        const transactions = []

        // get permission to spend the user's PXL balance on pxl_escrow
        const operators = [
          {
            add_operator: {
              owner: this.walletAddress,
              operator: process.env.VUE_APP_PXL_ESCROW,
              token_id: 0,
            },
          },
        ]
        transactions.push({
          kind: OpKind.TRANSACTION,
          ...pxlMain.methods.update_operators(operators).toTransferParams(),
        })

        transactions.push({
          kind: OpKind.TRANSACTION,
          ...pxlEscrow.methods.deposit(pxlAmount).toTransferParams(),
        })

        const batch = await this.tezos.wallet.batch(transactions)
        op = await batch.send()
        // Hide the modal manually
        this.$nextTick(() => {
          this.$bvModal.hide('deposit')
        })
        this.blockchainToast()
        const result = await op.confirmation(1)
        // go ahead and update the balance on the front end - trusting that the database is being updated via the admin script
        this.$store.commit('updatePxlBalance', {
          available: this.pxlBalance.available + pxlAmount,
          total: this.pxlBalance.total + pxlAmount,
        })
        this.successToast()
      } catch (error) {
        console.error('error trying to deposit $PXL', error)
        handleGlobalError(this, error, 'deposit $PXL')
      }
    },
    checkFormValidity() {
      // Why the crap doesn't this work???
      // const valid = this.$refs.depositForm.checkValidity()
      // console.log('checking validity', valid)
      // return valid

      let valid = true
      const pxlAmount = convertToMutez(this.amount)
      if (this.amount <= 10) {
        this.$bvToast.toast(`Deposit must be greater than 10.`, {
          title: 'Warning',
          variant: 'warning',
          solid: true,
          toaster: 'b-toaster-top-center',
        })
        valid = false
      }
      if (pxlAmount > this.config.maxDeposit) {
        this.$bvToast.toast(
          `Deposit is limited to ${convertFromMutez(this.config.maxDeposit)} $PXL.`,
          {
            title: 'Warning',
            variant: 'warning',
            solid: true,
            toaster: 'b-toaster-top-center',
          }
        )
        valid = false
      }
      return valid
    },
    async handleSubmit(e) {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        // prevent modal from closing
        e.preventDefault()
        return false
      }
      await this.depositPxl()
    },
    blockchainToast() {
      this.$bvToast.toast('Please wait up to 1 min for block confirmation.', {
        title: 'Please wait',
        variant: 'info',
        solid: true,
        toaster: 'b-toaster-top-center',
        noAutoHide: true,
      })
    },
    successToast() {
      this.$bvToast.toast(
        'Deposit successful. Please wait up to 2 min for funds to be available in the PixelDebates game',
        {
          title: 'Deposit Success!',
          variant: 'success',
          solid: true,
          toaster: 'b-toaster-top-center',
          noAutoHide: true,
        }
      )
    },
  },
}
</script>
